export const PHONE_COMPANIES_MOCK = [
  { name: 'Claro' },
  { name: 'Personal' },
  { name: 'Movistar' },
  { name: 'Nextel' },
  { name: 'Sin información' },
];

export const PHONE_COMPANY_GET_ENDPOINT =
  '/api/servicios_fijos/v1/phone_companies';
export const PHONE_COMPANIES_GET_OK_RESPONSE = {
  phoneCompanies: PHONE_COMPANIES_MOCK,
};
